export const icons = {
  ADD: 'add',
  EDIT: 'edit',
  VIEW: 'visibility',
  DELETE: 'delete',
  DONE: 'done',
  CALENDAR: 'calendar_today',
  COPY: 'content_copy',
  SEARCH: 'search',
}
